import { useCallback } from 'react';
import { getCountry } from '../../master-data';

export const useCountryNameFetcher = () => {
  return useCallback(async (countryCode) => {
    const country = await getCountry(countryCode);
    return country?.name || countryCode;
  }, []);
};

export const useParamsBuilder = (filters, formatDate, activeScenario) => {
  return useCallback(() => {
    const params = new URLSearchParams();
    const {
      startDateETA,
      endDateETA,
      startDateETD,
      endDateETD,
      destinationCountry,
      departureCountry,
      destinationPort,
      departurePort,
      shippingCompany,
      portOperator,
      market,
      imo,
      groupBy,
    } = filters;

    if (startDateETA) params.append('startDateETA', formatDate(startDateETA));
    if (endDateETA) params.append('endDateETA', formatDate(endDateETA));
    if (startDateETD) params.append('startDateETD', formatDate(startDateETD));
    if (endDateETD) params.append('endDateETD', formatDate(endDateETD));
    if (destinationCountry)
      params.append('destinationCountryCode', destinationCountry);
    if (departureCountry)
      params.append('departureCountryCode', departureCountry);
    if (destinationPort) params.append('destinationPortId', destinationPort);
    if (departurePort) params.append('departurePortId', departurePort);
    if (shippingCompany) params.append('carrier', shippingCompany);
    if (portOperator) params.append('portOperator', portOperator);
    if (market) params.append('marketCountryCode', market);
    if (imo) params.append('imo', imo);
    if (groupBy) params.append('groupBy', groupBy);
    if (activeScenario) params.append('scenarioId', activeScenario.id);

    return params;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, formatDate, activeScenario?.id]);
};
